import { atom } from 'jotai'

export const orderManagerModal = atom<{
  isOpen: boolean
  date: string | undefined
}>({ isOpen: false, date: undefined })
